import { FestivalButtons } from 'pages/custom/Festival/FestivalButtons';
import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { S_PageStyle } from 'pages/page/PageStyle';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const FestivalPageEN = (props: Props): JSX.Element => {
    return (
        <S_FjellseterPage className={props.className}>
            <CustomMapPage
                mapId={'51712355-2f59-40dc-a64b-7d63ca8d6b27'}
                header={{
                    logo: 'https://dvtqxks0zalev.cloudfront.net/2c69e2d2-7c0c-4539-944f-b0577a21052e.png',
                    logoText: 'Festival demo',
                    logoSubtext: '20.6.2023',
                    linkText: 'Web',
                    link: 'https://mapheim.com/'
                }}
                mapChildren={<></>}
                controls={<FestivalButtons programeId="2f52563f-3835-4005-ad79-95fb532422b1" />}
            />
        </S_FjellseterPage>
    );
};

const S_FjellseterPage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
    position: relative;
`;
